// import types
import { SpeechBubbleProps } from './SpeechBubble.types';
import {
  StyledSpeechBubbleWrapperBox,
  StyledSpeechBubbleBox,
  StyledSpeechBubbleTailBox
} from './SpeechBubble.styles';

const SpeechBubble = ({
  showAnimatedSpeechBubble,
  speechBubbleText = 'Need help?'
}: SpeechBubbleProps) => {
  return (
    <StyledSpeechBubbleWrapperBox
      showAnimatedSpeechBubble={showAnimatedSpeechBubble}
    >
      <StyledSpeechBubbleBox>
        {speechBubbleText}
        <StyledSpeechBubbleTailBox />
      </StyledSpeechBubbleBox>
    </StyledSpeechBubbleWrapperBox>
  );
};

export default SpeechBubble;
